module.exports = __webpack_public_path__ + "assets/img/resources.182502ee.svg";